export const ignoreMapClickLayers = [
  'meteorology-sigmet-layer-line',
  'meteorology-sigmet-layer-fill',

  'adhp-layer',
  'adhp-military-helipads',
  'adhp-helipads',
  'adhp-military-helipads-focused',
  'adhp-helipads-focused',
  'adhp-military-aerodromes-unpaved',
  'adhp-aerodromes-unpaved',
  'adhp-military-aerodromes-unpaved-focused',
  'adhp-aerodromes-unpaved-focused',
  'adhp-military-aerodromes-paved',
  'adhp-aerodromes-paved',
  'adhp-military-aerodromes-paved-focused',
  'adhp-aerodromes-paved-focused',
  'adhp-user-waypoints',
  'adhp-user-waypoints-focused',

  'map-procedure-chart-close-button-layer',
  'map-procedure-chart-layer',

  'fuel-with-price-layer',
  'fuel-with-price-icao-layer',
  'fuel-no-price-layer',
  'fuel-no-price-icao-layer',

  'map-obstacles-icons-layer',
  'map-obstacles-clusters-layer',
  'map-obstacles-selected-icons-layer',
  'map-obstacles-labels-layer',

  'map-navaids-icons-layer',
  'map-navaids-selected-icons-layer',
  'map-navaids-labels-layer',

  'route-waypoint-label',
  'route-waypoints-point'
]

// On-map buttons drawn above every other layer (the procedure chart's close
// button). A click on one of them must not also reach the features underneath —
// see `isMapControlClick`. The charts' opacity sliders are DOM markers and stop
// their own events (see MapChartOpacitySlider).
export const MAP_CONTROL_LAYER_IDS = ['map-procedure-chart-close-button-layer']

// User-geometry (KML/KMZ) layers are namespaced per geometry id, so their layer
// ids are dynamic (`user-geometry-{id}-polygon-fill`, `-line-{style}-line`,
// `-point`, …) and can never live in the static `ignoreMapClickLayers` list.
export const USER_GEOMETRY_LAYER_ID_PREFIX = 'user-geometry-'

// Airspace border/label layers are `airspace-{slug}-layer-border-line` and
// `airspace-{slug}-layer-symbol`, where `{slug}` is `slugifyAirspaceType(type)`
// (lowercase, dash-separated) since the JetStream migration. The slug is dynamic
// — multi-word (`ctaSector`→`ctasector`) and unknown dataset types included — so
// matching by pattern keeps every airspace type clickable without a per-type
// list that silently drifts out of sync (which is what broke CTA/setores).
// `airspace-layer-fill` (the active-selection fill) has no slug segment and is
// intentionally excluded.
const AIRSPACE_INTERACTIVE_LAYER_RE = /^airspace-.+-layer-(symbol|border-line)$/

// True for an airspace border/label layer id (see AIRSPACE_INTERACTIVE_LAYER_RE).
// Exported so presenters that build their own click-priority sets (meteorology,
// ADHP) also recognize airspace layers by pattern instead of a stale per-type list.
export const isAirspaceInteractiveLayer = (layerId: string): boolean => AIRSPACE_INTERACTIVE_LAYER_RE.test(layerId)

// True when a clicked layer should NOT trigger the generic map click (which
// closes the InfoPanel). Covers the static list, the dynamic user-geometry
// layers, and the dynamically-slugged airspace border/label layers.
export const isIgnoredMapClickLayer = (layerId: string): boolean =>
  ignoreMapClickLayers.includes(layerId) ||
  layerId.startsWith(USER_GEOMETRY_LAYER_ID_PREFIX) ||
  isAirspaceInteractiveLayer(layerId)
